import React from 'react'
import { ReactSVG } from 'react-svg'

const Collpsable = ({className = '', title = '',onEdit = ()  => {},onDelete = () => {}}) => {
  return (
    <div className={`flex border-gray-100 bg-gray-20 border-[1px] py-4  rounded-[4px] items-center justify-between ${className}`}>
        <p className='px-6 text-teal-600 text-body-lg font-bold'>{title}</p>
        <div className='flex items-center justify-between px-6  space-x-8'>
            <ReactSVG src='/icons/edit.svg' onClick={onEdit} className='w-4 cursor-pointer'/>
            <ReactSVG src='/icons/delete.svg' onClick={onDelete} className='w-4 cursor-pointer'/>
        </div>
    </div>
  )
}

export default Collpsable